// extracted by mini-css-extract-plugin
export default {"dragger":"FileUpload_dragger__SmKJ0","placeholder":"FileUpload_placeholder__wLyvm","disabled":"FileUpload_disabled__XpGD8"};